const apiRoute = {
  // Auth Module
  REFRESH_TOKEN: '/bankingservices/public/refreshtoken',
  LOGIN: '/bankingservices/public/login',
  LOGIN_OTP_GENERATE: '/bankingservices/public/otp/loginOtpGenerate',
  LOGIN_OTP_VERIFY: '/bankingservices/otp/verifyOtp',
  LOGOUT: '/bankingservices/logout',
  // RESET_PASSWORD_VERIFY: '/bankingservices/public/forgotPwd/verifyDetailsToResetPwd',
  RESET_PASSWORD_VERIFY: '/bankingservices/public/passwordReset/verify',
  // RESET_PASSWORD_UPDATE: '/bankingservices/public/forgotPwd/resetPwd',
  RESET_PASSWORD_UPDATE: '/bankingservices/public/passwordReset/confirm',
  GET_PASSWORD_CRITERIA: '/bankingservices/public/userRegistration/passwordCriteria',
  // REGISTER_USER: '/bankingservices/public/userRegistration/registerUser',
  REGISTER_USER: '/bankingservices/public/userRegistration/confirm',
  // CHECK_PASSWORD_CRITERIA: '/bankingservices/public/userRegistration/getUserPwdCriteria',
  CHECK_PASSWORD_CRITERIA: '/bankingservices/public/userRegistration/passwordCriteria',
  REGISTER_GENERATE_OTP: '/bankingservices/public/userRegistration/registrationOtpGenerate',
  VALIDATE_USERNAME: '/bankingservices/public/userRegistration/validateUserName',
  CHECK_CUST_BY_UNIQUE_ID: '/bankingservices/public/custOnboard/checkCustByUniqueID',
  // VERIFY_USER_DETAILS: '/bankingservices/public/userRegistration/verifyDetails',
  VERIFY_USER_DETAILS: '/bankingservices/public/userRegistration/verify',
  VERIFY_FORGOT_USERNAME: '/bankingservices/public/forgotUserName/verify',
  VERIFY_FORGOT_USERNAME_CONFIRM: '/bankingservices/public/forgotUserName/confirm',
  REGISTER_MPIN_VERIFY: '/bankingservices/public/userRegistration/quickLoginVerifyDetails',
  REGISTER_MPIN_CONFIRM: '/bankingservices/public/userRegistration/registerquickLogin',
  FORGOT_MPIN_VERIFY: '/bankingservices/public/userRegistration/quickLoginVerifyDetails',
  FORGOT_MPIN_CONFIRM: '/bankingservices/public/userRegistration/registerquickLogin',

  // Registration Module/bankingservices/public/accountEnquiry/accountSummary
  REGISTRATION_VERIFY_USER_DETAILS: '/bankingservices/public/userRegistration/verifyDetails',
  REGISTRATION_VALIDATE_USERNAME: '/bankingservices/public/userRegistration/validateUserName',
  REGISTRATION_CHECK_PASSWORD_CRITERIA: '/bankingservices/public/userRegistration/checkPwdCriteria',
  REGISTRATION_GENERATE_OTP: '/bankingservices/public/userRegistration/registrationOtpGenerate',
  REGISTRATION_SAVE_USER: '/bankingservices/public/userRegistration/registerUser',
  REGISTRATION_GET_PASSWORD_CRITERIA: '/bankingservices/public/userRegistration/checkPwdCriteria',
  UDF_DETAILS: '/bankingservices/public/userRegistration/udfDetails',

  // New Customer Module
  NEWCUSTOMER_GET_REQUIRED_VALUES: '/bankingservices/public/userRegistration/getRegistrationValues',
  NEWCUSTOMER_GET_COUNTRY_CODES: '/bankingservices/public/countryCode/list',
  NEWCUSTOMER_GET_BRANCH_CODES: '/bankingservices/public/custOnboard/getBranchDetails',
  // NEWCUSTOMER_GET_TERMS: '/bankingservices/public/userRegistration/terms',
  NEWCUSTOMER_GET_TERMS: '/bankingservices/public/information/termsAndConditions',
  NEWCUSTOMER_GENERATE_OTP: '/bankingservices/public/walletRegister/customerCreateOtpGenerate',
  NEWCUSTOMER_GET_EMP_DETAILS: '/bankingservices/public/custOnboard/getEmpDetails',
  NEWCUSTOMER_CREATE_CUSTOMER: '/bankingservices/public/walletRegister/createNewCustomer',
  VALIDATEID: '/bankingservices/public/walletRegister/validateId',
  REGISTRATION_MIS_CODE: '/bankingservices/public/walletRegister/getMISCode',

  // Profile Module
  GET_PROFILE_DETAILS: '/bankingservices/profile/get',

  // Accounts Module
  GET_ACCOUNTS: '/bankingservices/accounts/getAll',
  GET_LOAN_ACCOUNT_DETAILS: '/bankingservices/public/accountEnquiry/getLoanAccountDetails',
  GET_SI_LIST: '/bankingservices/si/getSiList',
  GET_CASA_ACCOUNT_DETAILS: '/bankingservices/public/accountEnquiry/getCasaAccountDetails',
  GET_DEPOSIT_ACCOUNT_DETAILS: '/bankingservices/accounts/getDepositAccountDetails',
  // GET_ACCOUNT_STATEMENT: '/bankingservices/public/accountEnquiry/fullStatement',
  GET_ACCOUNT_STATEMENT: '/bankingservices/accounts/fullStatement',
  GET_ACCOUNT_MINI_STATEMENT: '/bankingservices/accounts/getAccountMiniStatement',

  // Deposits Module
  GET_TERMS_AND_CONDITIONS: '/bankingservices/public/information/termsAndConditions',
  GET_TENOR_LIST: '/bankingservices/termDeposit/getInterestRates',
  GET_PRODUCTS: '/bankingservices/termDeposit/getProducts',
  DEPOSIT_CURRENCY_LIST: '/bankingservices/termDeposit/currencyList',
  CREATE_TERM_DEPOSIT: '/bankingservices/termDeposit/verify',
  CREATE_TERM_DEPOSIT_CONFIRM: '/bankingservices/termDeposit/confirm',
  GET_DEPOSIT_STATEMENT: '/bankingservices/termDeposit/getDepositAccountStatement',
  TOP_UP_DEPOSIT_VERIFY: '/bankingservices/public/termDeposit/tdTopupVerify',
  TOP_UP_DEPOSIT_CONFIRM: '/bankingservices/public/termDeposit/tdTopupConfirm',
  REEDEM_DEPOSIT_VERIFY: '/bankingservices/public/termDeposit/tdRedeemVerify',
  REEDEM_DEPOSIT_CONFIRM: '/bankingservices/public/termDeposit/tdRedeemConfirm',

  // Loans Module
  GET_LOAN_REQUEST_VALUES: '/bankingservices/loan/getLoanRequestValues',
  REQUEST_NEW_LOAN: '/bankingservices/loan/loanRequest',
  REQUEST_LOAN_REPAY_VERIFY: '/bankingservices/loan/loanRepayVerify',
  REQUEST_LOAN_REPAY_CONFIRM: '/bankingservices/loan/loanRepayConfirm',

  GET_LOAN_DETAILS: '/bankingservices/loan/getLoanAccountDetails',
  GET_LOAN_STATEMENT: '/bankingservices/loan/getLoanAccountStatement',

  // Requests Module
  GET_BRANCH_DETAILS: '/bankingservices/userActivity/getBranchDetails',
  GET_CHEQUE_BOOK_ELIGIBILITY: '/bankingservices/request/validateAccChequeFlag',
  CHEQUE_BOOK_VERIFICATION: '/bankingservices/request/chequeBookVerification',
  CHEQUE_BOOK_CONFIRMATION: '/bankingservices/request/chequeBookConfirmation',
  CHEQUE_BOOK_STATUS_VERIFY: '/bankingservices/request/chequeStatusVerification',
  CHEQUE_BOOK_STATUS_CHANGE_CONFIRM: '/bankingservices/request/chequeStatusConfirmation',
  STOP_CHEQUE_VERIFY: '/bankingservices/request/stopChequeVerification',
  CONFIRM_CHEQUE_STOP: '/bankingservices/request/stopChequeConfirmation',
  CHEQUE_BOOK_STATUS_ENQUIRY: '/bankingservices/request/chequeBookStatusInquiry',
  CREATE_SI_REQUEST: '/bankingservices/si/create/verify',
  CONFIRM_CREATE_SI_REQUEST: '/bankingservices/si/create/confirm',
  GET_CARD_LIST: '/bankingservices/card/getCardDetails',
  BLOCK_DEBIT_CARD_VERIFY: '/bankingservices/card/blockdebitcardverify',
  BLOCK_DEBIT_CARD_CONFIRM: '/bankingservices/card/blockdebitcardconfirm',
  GET_CARD_ACCOUNTS: '/bankingservices/public//request/getCardAccounts',
  VERIFY_CARD_LOAD: '/bankingservices/public/request/cardLoadVerify',
  CONFIRM_CARD_LOAD: '/bankingservices/public/request/cardLoadConfirm',
  GET_ENCRYPTED_KEY: '/bankingservices/public/request/getEncryptedKey',
  CHANGE_CARD_PIN: '/bankingservices/public/request/changeCardPin',
  STOP_CHEQUE_REASON_LIST: '/bankingservices/userActivity/getStopChequeReasonList',
  DEBIT_CARD_REQUEST_VERIFY: '/bankingservices/card/debitcardreqverify',
  DEBIT_CARD_REQUEST_CONFIRM: '/bankingservices/card/debitcardreqconfirm',
  GET_CARD_DEATILS: '/bankingservices/card/getCardProductDetails',

  // Branches Module
  GET_LOCATIONS: '/bankingservices/public/getLocations',
  // GET_BRANCH_LOCATIONS: '/bankingservices/public/branchLocation',
  // GET_AGENT_LOCATIONS: '/bankingservices/public/agentLocation',

  // TRANSFERS
  VERIFY_INTERNAL_BENEFICIARY:
    '/bankingservices/public/beneficiary/internalBenificiaryVerification',
  VERIFY_TRANSFER: '/bankingservices/transfer/verify',
  // CONFIRM_TRANSFER: '/bankingservices/public/ft/ftConfirm',
  CONFIRM_TRANSFER: '/bankingservices/transfer/confirm',
  // transactionsForRepeat: '/bankingservices/receipt/transactionsForRepeat',
  GET_ALL_BENEFICIARIES: '/bankingservices/beneficiary/getAllBeneficiaries',
  // GET_ALL_BANKS: '/bankingservices/public/ft/getBankDetails',
  GET_ALL_BANKS: '/bankingservices/transfer/otherBanksList',
  GET_ALL_COUNTRIES: '/bankingservices/public/information/getSwiftCountry',
  GET_ALL_INTERNATIONAL_BANKS: '/bankingservices/public/information/getInternationalBankDetails',
  VERIFY_ADD_INTERNAL_BENEFICIARY: '/bankingservices/beneficiary/internalBeneficiaryVerification',
  CONFIRM_ADD_INTERNAL_BENEFICIARY: '/bankingservices/beneficiary/addInternalBeneficiary',
  VERIFY_REMOVE_BENEFICIARY: '/bankingservices/beneficiary/removeBeneficiaryotp',
  REMOVE_BENEFICIARY: '/bankingservices/beneficiary/removeBeneficiary',
  ADD_THIRD_PARTY_BENEFICIARY: '/bankingservices/beneficiary/addThirdpartyBeneficiary',
  VERIFY_ADD_THIRD_PARTY_BENEFICIARY: '/bankingservices/beneficiary/otherBeneficiaryVerification',
  CHANGE_BENEFICIARY_IMAGE: '/bankingservices/beneficiary/updateBeneImage',
  DELETE_BENEFICIARY_IMAGE: '/bankingservices/beneficiary/deleteBeneImage',
  GET_BENEFICIARY_IMAGES: '/bankingservices/beneficiary/getBeneImages',
  VERIFY_EDIT_INTERNAL_BENEFICIARY: '/bankingservices/beneficiary/modifyInternalBeneficiaryotp',
  CONFIRM_EDIT_INTERNAL_BENEFICIARY: '/bankingservices/beneficiary/modifyInternalBeneficiary',
  VERIFY_EDIT_THIRDPARTY_BENEFICIARY: '/bankingservices/beneficiary/modifyThirdpartyBeneficiaryotp',
  CONFIRM_EDIT_THIRDPARTY_BENEFICIARY: '/bankingservices/beneficiary/modifyThirdpartyBeneficiary',
  LAST_N_TRANSACTIONS: '/bankingservices/receipt/transactions',
  RECIEPT_TRANSFER: '/bankingservices/receipt/transactions',
  DOWNLOAD_RECEIPT: '/bankingservices/receipt/download',
  DOWNLOAD_MT103_RECEIPT: '/bankingservices/fundtransfer/downloadMsgCode',
  DOWNLOAD_BI_STATEMENT: '/bankingservices/userActivity/biStatement',
  GET_PDF_REPORT: 'bankingservices/download/statement',
  CURRENCY_LIST: '/bankingservices/transfer/currencyList',
  CHARGE_FT: '/bankingservices/public/accountMapping/chargeForFT',
  VIEW_SCHEDULED_TRANSFER: '/bankingservices/scheduledTransfer/viewScheduledTransfer',
  VERIFY_SCHDULED_TRANSFER: '/bankingservices/scheduledTransfer/cancelScheduledTransferVerify',
  CONFIRM_SCHEDULED_TRANSFER: '/bankingservices/scheduledTransfer/cancelScheduledTransferConfirm',
  DOWNLOAD_PAYMENT_RECEIPT: '/bankingservices/receipt/download',

  VERIFY_REGESTRATION: '/bankingservices/public/userRegistration/verifylink',
  // PAYMENTS
  GET_ALL_BILLERS: '/bankingservices/bp/getBillProducts',
  getServiceById: '/bankingservices/bp/getServiceById',
  getPendingBills: '/bankingservices/bp/getPendingBills',
  GET_ALL_BILLER_BENEFICIARIES: '/bankingservices/bp/getBillerBeneficiary',
  ADD_BILLER_BENEFICIARY: '/bankingservices/bp/addBillerBeneficiary',
  GET_BILL_QUOTE: '/bankingservices/bp/bpQuote',
  PAY_BILL: '/bankingservices/bp/billPay',
  GET_DELETE_BILLER_BENEFICIARIES: '/bankingservices/bp/deleteBillerBeneficiary',
  VIEW_SCHEDULED_PAYMENT: '/bankingservices/scheduledPayment/view', //change
  VERIFY_SCHDULED_PAYMENT: '/bankingservices/scheduledPayment/cancelVerify', //change
  CONFIRM_SCHEDULED_PAYMENT: '/bankingservices/scheduledPayment/cancelConfirm', //change

  TD_INTEREST_RATE_LIST: '/bankingservices/termDeposit/tdInterestRatesList',
  // PayDay Loan
  GET_ELIGIBILITY_LOAN_AMOUNT: '/instantloanservices/instantLoan/getEligibilityLoanAmount',
  PAYDAY_LOAN_TERMS_AND_CONDITIONS: '/instantloanservices/instantLoan/termsAndConditions',
  PAYDAY_LOAN_INTEREST_CHARGE: '/instantloanservices/instantLoan/interestCharge',
  REQUEST_INSTANT_LOAN_VERIFICATION: '/instantloanservices/instantLoan/requestInstantLoan',
  PAYDAY_LOAN_GENERATE_OTP: '/instantloanservices/otp/generateOtp',
  REQUEST_INSTANT_LOAN_CONFIRMATION: '/instantloanservices/instantLoan/requestInstantLoanConfirm',

  // QuickPay Module
  GET_TRANSFER_TYPES: '/bankingservices/public/beneficiary/getThirdpartyTransferTypes',
  // FUND_TRANSFER_VERIFY: '/bankingservices/public/ft/ftVerify',
  FUND_TRANSFER_VERIFY: '/bankingservices/transfer/verify',
  FUND_TRANSFER_CONFIRM: '/bankingservices/transfer/confirm',

  // Calculator Module
  CALCULATE_LOAN_DEPOSIT: '/bankingservices/public/information/calLoanDep',

  // FAQ Module
  GET_FAQ: '/bankingservices/public/information/userfaq',

  // Feedback Module
  GET_FEEDBACK_COMPLAINT_CATEGORY: '/bankingservices/userActivity/getComplaintFeedbackCatg',
  ADD_FEEDBACK: '/bankingservices/userActivity/feedback',

  // Exchange Rates Module
  GET_CURRENCY_VALUES: '/bankingservices/public/userActivity/currencyValues',
  GET_BUYCURRENCY_VALUES: '/bankingservices/public/userActivity/buyCurBasedOnSellCur',
  GET_EXCHANGE_RATES: '/bankingservices/public/userRegistration/cbsrates',
  GET_ALL_EXCHANGE_RATES: '/bankingservices/public/information/getCrossCurrencyRates',

  // Send to Mobile
  GET_WALLET_LIST: '/bankingservices/userActivity/getWalletList',
  VERIFY_SEND_TO_MOBILE: '/bankingservices/fundtransfer/bankToWalletVerify',
  CONFIRM_SEND_TO_MOBILE: '/bankingservices/fundtransfer/bankToWalletConfirm',

  // Profile Module
  GET_PROFILE_IMAGE: '/bankingservices/profile/getImage',
  DELETE_PROFILE_IMAGE: '/bankingservices/profile/deleteImage',

  UPDATE_PROFILE_IMAGE: '/bankingservices/profile/uploadImage',

  // Notifications Module
  GET_CUST_NOTIFICATIONS: '/bankingservices/userActivity/getCustNotifications',

  // Settings Module
  GET_USER_PWD_CRITERIA: '/bankingservices/public/userRegistration/checkPwdCriteria',
  CHANGE_PWD_REQUEST: '/bankingservices/profile/changePwd',
  CHANGE_MPIN: '/bankingservices/public/userActivity/changeMpinPwd',
  ADD_NICK_NAME: '/bankingservices/accounts/setNickName',
  //deLink Account
  DE_LINK_ACCOUNT_VERIFY: '/bankingservices/accounts/delinkVerify',
  DE_LINK_ACCOUNT: '/bankingservices/accounts/delinkConfirm',

  //link Account
  LINK_ACCOUNT_VERIFY: '/bankingservices/accounts/linkVerify',
  LINK_ACCOUNT: '/bankingservices/accounts/linkConfirm',

  // Offers
  GET_OFFERS: '/bankingservices/public/information/getOffers',

  GET_CONTACTUS_VALUES: '/bankingservices/public/information/contactUs',

  //Assets and Liabilities

  // GET_BALANCES: '/bankingservices/public/accountEnquiry/getBalances',
  GET_BALANCES: '/bankingservices/accounts/getBalances',

  // Add Funding account for account creation
  GET_ACCOUNT_CLASS: '/bankingservices/accountClass/getAccountClasses',
  CREATE_CASA_ACCOUNT_VERIFY: '/bankingservices/accCreate/createCASAAccountVerify',
  CREATE_CASA_ACCOUNT_CONFIRM: '/bankingservices/accCreate/createCASAAccountConfirm',

  //school
  GET_ALL_OTHER_PAYMENTS_LIST: '/bankingservices/schoolpay/institutionsList',
  GET_STUDENT_NAME: '/bankingservices/schoolpay/studentDetails',
  OTHER_BILL_PAYMENTS_VERIFY: '/bankingservices/schoolpay/studentpaymentverify',
  OTHER_BILL_PAYMENTS_CONFIRM: '/bankingservices/schoolpay/studentpaymentconfirm',

  //other payments
  GET_ALL_UTILITY_PAYMENTS_LIST: '/bankingservices/schoolpay/utilitiesList',
  GET_UTILITY_STUDENT_NAME: '/bankingservices/schoolpay/customerDetails',
  OTHER_UTILITY_PAYMENTS_VERIFY: '/bankingservices/schoolpay/utilitypaymentverify',
  OTHER_UTILITY_PAYMENTS_CONFIRM: '/bankingservices/schoolpay/utilitypaymentconfirm',

  // Send To Mobile
  MOBILE_TRANSFER_VERIFY: '/bankingservices/public/mobileTransfer/mobileTransferVerify',
  MOBILE_TRANSFER_CONFIRM: '/bankingservices/public/mobileTransfer/mobileTransferConfirm',

  // Provision for adding any other utility bill payment
  RD_CREATE_VERIFY: '/bankingservices/public/rd/rdCreateVerify',
  RD_CREATE_CONFIRM: '/bankingservices/public/rd/rdCreateConfirm',

  //remarks category
  // REMARKS_CATEGORY: '/bankingservices/public/userActivity/getRemarksCategory',
  REMARKS_CATEGORY: '/bankingservices/userActivity/getRemarksCategory',

  //service request
  SERVICE_REQUEST: '/bankingservices/public/userActivity/serviceRequest',
  SERVICE_REQUEST_VIEW: '/bankingservices/public/userActivity/serviceRequestView',
  GET_MT103_REFNUMBERS: '/bankingservices/fundtransfer/getSwiftAndRtgsRef',
  GET_LIST_OF_FORMAT: '/bankingservices/userActivity/getListOfFormat',

  //terms and conditions
  GET_TERMS_AND_CONDITIONS: '/bankingservices/public/information/termsAndConditions',

  featureCheck: '/bankingservices/userActivity/featureCheck',
  cardlessGenTokenVerify: '/bankingservices/cardless/cardlessGenTokenVerify',
  cardlessGenToken: '/bankingservices/cardless/cardlessGenToken',
  cardlessViewToken: '/bankingservices/cardless/cardlessViewToken',
  cardlessCancelToken: '/bankingservices/cardless/cardlessCancelToken',

  GET_ALL_COUNTRY_CODES: '/bankingservices/public/countryCode/list',

  GET_GIMAC_PROVIDER_LIST: '/bankingservices/gimac/getGimacProviderList',
  GIMAC_LAST_N_TRANSACTIONS: '/bankingservices/gimac/walletTransactions',
  DOWNLOAD_GIMAC_RECEIPT: '/bankingservices/gimac/walletReceiptDownload',
  GIMAC_VERIFY: '/bankingservices/gimac/verify',
  GIMAC_CONFIRM: 'bankingservices/gimac/confirm',
  GIMAC_CARDLESS_CASH: "/bankingservices/gimac/walletCardlessTransactions",
  GIMAC_DOWNLOAD: "bankingservices/gimac/walletCardlessReceiptDownload",
  GIMAC_LAST_N_TRANSACTION_INCOMING: "bankingservices/gimac/walletIncomingTransactions"
}

const config = {
  apiRoute,
}

export default config
